import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import useMedia from "../componentsofcourse/useMedia";
import Select from "react-select";
import "./InternalForm.css";
import { Redirect } from "react-router-dom";
import { BASE_URL } from "../env";

const PROJECT_STRUCT = {
	// projectId: "",
	description: "",
	duration: "",
	status: "",
	project: "",
};

const EmployeeForm = () => {
	const [projectCounter, setProjectCounter] = useState([]);
	const [startTime, setStartTime] = useState("");
	const [endTime, setEndTime] = useState("");
	const [department, setDepartment] = useState("");
	const [manager, setManager] = useState("");
	const [employeeCode, setEmployeeCode] = useState("code");
	const [internId, setInternId] = useState("");
	const [status, setStatus] = useState("");
	const [project, setProject] = useState("");
	const [projectId, setProjectId] = useState("");
	const [description, setDescription] = useState("");
	const [duration, setDuration] = useState("");
	const [data, setData] = useState([]);
	const [dataFromGetEmployee, setDataFromGetEmployee] = useState([]);
	const [managerOptions, setManagerOptions] = useState([]);
	const [projectOptions, setProjectOptions] = useState([]);
	const [logoutClickedOnInternForm, setLogoutClickedOnInternForm] =
		useState(false);
	const [stTime, setStTime] = useState("");
	const [employeeLoggedIn, setEmployeeLoggedIn] = useState(false);
	const loginClicked = () => {
		let loginTime = new Date();
		loginTime = loginTime.toLocaleString("en-US", {
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		});
		//   console.log(dataFromGetIntern.message.employeeCode, "employeeCode");
		fetch(BASE_URL + "/EmployeeAtnd", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify({
				isLogin: true,
				employeeCode: dataFromGetEmployee.message.employeeCode,
				reportingManager: "-",
				department: "-",
				login: loginTime,
				logout: "-",
				tasks: [
					{
						project: "",
						duration: "-",
						status: "Ongoing",
						description: "-",
						projectId: "-",
					},
				],
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				console.log("Data from Add Task ", data);
			})
			.then(() => {
				fetch(BASE_URL + "/getMe", {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						authorization: localStorage.getItem("token"),
					},
				})
					.then((res) => res.json())
					.then((data) => {
						console.log(data);
						setDataFromGetEmployee(data);
						console.log(
							"Data from Get employee Login",
							dataFromGetEmployee
						);
						console.log("Data from Get employee Login", data);
						if (data?.message?.isLogin == true) {
							setEmployeeLoggedIn(data.message.isLogin);
							window.location.reload();
							console.log(employeeLoggedIn);
						} else {
							setEmployeeLoggedIn(data?.message?.isLogin);
							console.log(employeeLoggedIn);
						}
					});
			})
			.catch((err) => {
				console.log("Error from add task", err);
			});
	};
	useEffect(() => {
		fetch(BASE_URL + "/getMe", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setDataFromGetEmployee(data);
				console.log(
					"Data from Get employee Login",
					dataFromGetEmployee
				);
				console.log("Data from Get employee Login", data);
				setEmployeeCode(data?.message?.employeeCode);
				if (data?.message?.isLogin == true) {
					setEmployeeLoggedIn(data?.message?.isLogin);
					console.log(employeeLoggedIn);
				} else {
					setEmployeeLoggedIn(data?.message?.isLogin);
					console.log(employeeLoggedIn);
				}
				return data;
			})
			.then((tsk) => {
				if (tsk?.task?.login !== undefined) {
					setStTime(tsk.task.login);
				}
			});
	}, []);
	useEffect(() => {
		fetch(BASE_URL + "/getProfile", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				//check if user is an intern here.
			});
	}, []);
	const formSubmit = async (e) => {
		e.preventDefault();
		let logoutTime = new Date();
		logoutTime = logoutTime.toLocaleString("en-US", {
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		});
		let addtsk = projectCounter;
		let tsk = [
			{
				project: project.toString(),
				duration,
				description,
				// projectId: projectIdCode + projectId,
				status,
			},
			...addtsk,
		];
		await fetch(BASE_URL + "/UpdateLogout", {
			method: "POST",
			headers: {
				"content-Type": "application/json",
				authorization: "Bearer " + localStorage.getItem("token"),
			},
			body: JSON.stringify({
				isLogin: false,
				employeeCode: employeeCode,
				login: stTime,
				logout: logoutTime,
				department,
				reportingManager: manager,
				tasks: tsk,
			}),
		}).then(() => {
			fetch(BASE_URL + "/getMe", {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					authorization: localStorage.getItem("token"),
				},
			})
				.then((res) => res.json())
				.then((data) => {
					setDataFromGetEmployee(data);
					console.log(
						"Data from Get Intern Login",
						dataFromGetEmployee
					);
					console.log("Data from Get Intern Login", data);
					if (data?.message?.isLogin == true) {
						setEmployeeLoggedIn(data.message.isLogin);
						console.log(employeeLoggedIn);
					} else {
						setEmployeeLoggedIn(data?.message?.isLogin);
						console.log(employeeLoggedIn);
					}
				})
				.then(() => {
					setLogoutClickedOnInternForm(false);
				});
		});
		console.log({
			employeeCode: employeeCode + internId,
			startTime,
			endTime,
			department,
			reportingManager: manager,
			tasks: tsk,
		});
	};

	const departmentOptions = [
		{ value: "Management", label: "Management" },
		{ value: "Business Analytics B2B", label: "Business Analytics B2B" },
		{ value: "Business Analytics B2C", label: "Business Analytics B2C" },
		{
			value: "Campus Ambassador Program",
			label: "Campus Ambassador Program",
		},
		{
			value: "Corporate Connect Project",
			label: "Corporate Connect Project",
		},
		{ value: "Content Development", label: "Content Development" },
		{ value: "Content Writing", label: "Content Writing" },
		{ value: "CXO Advisory", label: "CXO Advisory" },
		{ value: "Graphic Design", label: "Graphic Design" },
		{ value: "Human Resource", label: "Human Resource" },
		{ value: "Instacks", label: "Instacks" },
		{ value: "Operations", label: "Operations" },
		{ value: "Power BI", label: "Power BI" },
		{ value: "Product Management", label: "Product Management" },
		{ value: "Sales & BD", label: "Sales & BD" },
		{ value: "Social Media", label: "Social Media" },
		{ value: "Web Development", label: "Web Development" },
		{ value: "Resources", label: "Resources" },
	];
	const [projectIdCode, setProjecIdCode] = useState("code");
	useEffect(async () => {
		if (department === "Management") setProjecIdCode("P-MG-");
		if (department === "Business Analytics B2B")
			setProjecIdCode("P-B2B-BA-");
		if (department === "Business Analytics B2C")
			setProjecIdCode("P-B2C-BA-");
		if (department === "Campus Ambassador Program")
			setProjecIdCode("P-CAP-");
		if (department === "Corporate Connect Project")
			setProjecIdCode("P-CCP-");
		if (department === "Content Development") setProjecIdCode("P-CD-");
		if (department === "Content Writing") setProjecIdCode("P-CW-");
		if (department === "CXO Advisory") setProjecIdCode("P-CXOA-");
		if (department === "Graphic Design") setProjecIdCode("P-GD-");
		if (department === "Human Resource") setProjecIdCode("P-HR-");
		if (department === "Instacks") setProjecIdCode("P-INS-");
		if (department === "Operations") setProjecIdCode("P-OPR-");
		if (department === "Power BI") setProjecIdCode("P-PBI-");
		if (department === "Product Management") setProjecIdCode("P-PM-");
		if (department === "Sales & BD") setProjecIdCode("P-S&BD-");
		if (department === "Social Media") setProjecIdCode("P-SM-");
		if (department === "Web Development") setProjecIdCode("P-WD-");
		if (department === "Resources") setProjecIdCode("P-R-");
	}, [department]);

	return (
		<>
			<section id="interns-form">
				<div className="container-fluid p-0">
					<div className="row">
						<div className="col-md-10 intern-form-portion mb-0 mx-auto shadow">
							<div className="intern-form-heading">
								Employee Attendance
							</div>
							<div className="row mx-auto">
								<div className="col-6">
									<button
										disabled={
											employeeLoggedIn ? true : false
										}
										onClick={() => {
											loginClicked();
										}}
										className={
											employeeLoggedIn
												? "submit-intern-form-btn-2 btn-success m-0 disabled"
												: "submit-intern-form-btn-2 btn-success m-0 "
										}
									>
										Login
									</button>
									{stTime && employeeLoggedIn === true ? (
										<h3
											className="mt-5 "
											style={{ color: "grey" }}
										>
											You logged in at :-{" "}
											<b style={{ color: "#185adb" }}>
												{stTime}
											</b>
										</h3>
									) : (
										""
									)}
								</div>
								<div className="col-6 ">
									<button
										disabled={
											employeeLoggedIn ? false : true
										}
										onClick={() => {
											setLogoutClickedOnInternForm(
												!logoutClickedOnInternForm
											);
										}}
										className={
											employeeLoggedIn
												? "submit-intern-form-btn-2 btn-danger m-0 disabled"
												: "submit-intern-form-btn-2 btn-danger m-0 "
										}
									>
										Logout
									</button>
								</div>
								{logoutClickedOnInternForm ? (
									<form className="col-12">
										<div className="col-md-12 m-0">
											<label
												for="inputDepartment"
												className="form-label"
											>
												Department
												<span className="asterisk">
													*
												</span>
											</label>
											<Select
												options={departmentOptions}
												className="mb-4"
												name="department"
												value={departmentOptions.find(
													(obj) =>
														obj.value === department
												)}
												onChange={async (event) => {
													setDepartment(event.value);
													// console.log(event.value)
													await fetch(
														BASE_URL +
															"/departmentInfo/" +
															event.value
													)
														.then((res) =>
															res.json()
														)
														.then((data) => {
															console.log(
																data.project
																	.Project
															);
															setData(data);
															let managersTemp =
																	[],
																projectsTemp =
																	[];
															data.project.Project.map(
																(
																	oneProject
																) => {
																	projectsTemp.push(
																		{
																			value: oneProject.name,
																			label: oneProject.name,
																		}
																	);
																}
															);
															setProjectOptions(
																projectsTemp
															);
															console.log(
																projectsTemp
															);

															data.project.Manager.map(
																(
																	oneManager
																) => {
																	managersTemp.push(
																		{
																			value: oneManager,
																			label: oneManager,
																		}
																	);
																}
															);
															setManagerOptions(
																managersTemp
															);
														});
												}}
											/>
										</div>
										<div className="col-md-12 m-0">
											<label
												for="inputReportingManager"
												className="form-label"
											>
												Reporting Manager
												<span className="asterisk">
													*
												</span>
											</label>
											<Select
												options={managerOptions}
												className="mb-4"
												name="manager"
												value={managerOptions.find(
													(obj) =>
														obj.value === manager
												)}
												onChange={(event) => {
													setManager(event.value);
												}}
											/>
										</div>
										<div className="col-12 m-0">
											<label
												for="inputInternCode"
												className="form-label"
											>
												Employee Code
												<span className="asterisk">
													*
												</span>
											</label>
											{/* <div className="d-flex flex-row"> */}
											<input
												style={{
													color: "grey",
													fontWeight: "bold",
													width: "50%",
												}}
												// onChange={handleCode}
												type="text"
												className="form-control"
												id="inputWorkEnding"
												disabled
												value={employeeCode}
											/>
										</div>

										<br />
										<div className="col-12 m-0">
											<label
												for="project"
												className="form-label"
											>
												Projects
												<span className="asterisk">
													*
												</span>
											</label>

											<Select
												options={projectOptions}
												className="mb-4"
												name="project"
												value={projectOptions.find(
													(obj) =>
														obj.value === project
												)}
												onChange={(event) => {
													setProject(event.value);
												}}
											/>
										</div>
										<div className="col-12">
											<label
												for="status"
												className="form-label"
											>
												Status
												<span className="asterisk">
													*
												</span>
											</label>
											<br />
											<input
												type="radio"
												className="form-radio"
												id="projects"
												name="status"
												onClick={() =>
													setStatus("Completed")
												}
											/>{" "}
											Completed
											<input
												style={{ marginLeft: "2rem" }}
												type="radio"
												className="form-radio"
												id="status"
												name="status"
												onClick={() =>
													setStatus("Ongoing")
												}
											/>{" "}
											Ongoing
											<input
												style={{ marginLeft: "2rem" }}
												type="radio"
												className="form-radio"
												id="status"
												name="status"
												onClick={() =>
													setStatus("Halted")
												}
											/>{" "}
											Halted
										</div>
										<div className="col-12 m-0">
											<label
												for="duration"
												className="form-label"
											>
												Duration(Minutes)
												<span className="asterisk">
													*
												</span>
											</label>
											<input
												type="number"
												className="form-control"
												id="duration"
												value={duration}
												onChange={(event) => {
													let e = event.target.value;
													setDuration(e);
												}}
											/>
										</div>
										<br />
										<div className="col-12 m-0">
											<label
												for="description"
												className="form-label"
											>
												Description
												<span className="asterisk">
													*
												</span>
											</label>
											<input
												type="text"
												className="form-control"
												id="description"
												value={description}
												onChange={(event) => {
													let e = event.target.value;
													setDescription(e);
												}}
											/>
										</div>

										<br />
										<div>
											{projectCounter.map(
												(oneElement, index) => (
													<div
														style={{
															border: "1px solid #999",
														}}
														key={index}
													>
														<div className="col-12">
															<div className="row">
																<div className="col-12 mb-0 mt-3">
																	<label
																		for="projectName"
																		className="form-label"
																	>
																		Project
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																</div>
																<div className="col-md-12 mb-0">
																	<Select
																		options={
																			projectOptions
																		}
																		className="mb-4"
																		name="project"
																		value={projectOptions.find(
																			(
																				obj
																			) =>
																				obj.value ===
																				projectCounter[
																					index
																				]
																					.project
																		)}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								event.value,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									event.value,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									event.value,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								event.value,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																		}}
																	/>
																</div>
																<br />

																<br />
																<div className="col-12">
																	<label
																		for="status"
																		className="form-label"
																	>
																		Status
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																	<br />
																	<input
																		type="radio"
																		className="form-radio"
																		id="projects"
																		name={
																			"status" +
																			index
																		}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Completed",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Completed",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Completed",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Completed",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>{" "}
																	Completed
																	<input
																		style={{
																			marginLeft:
																				"2rem",
																		}}
																		type="radio"
																		className="form-radio"
																		id="status"
																		name={
																			"status" +
																			index
																		}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>{" "}
																	Ongoing
																	<input
																		style={{
																			marginLeft:
																				"2rem",
																		}}
																		type="radio"
																		className="form-radio"
																		id="status"
																		name={
																			"status" +
																			index
																		}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Halted",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Halted",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Halted",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Halted",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																		}}
																	/>{" "}
																	Halted
																</div>
																<div className="col-md-12 m-0">
																	<label
																		for="duration"
																		className="form-label"
																	>
																		Duration(Minutes)
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																	<input
																		type="number"
																		className="form-control"
																		id="duration"
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								event
																									.target
																									.value,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									event
																										.target
																										.value,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									event
																										.target
																										.value,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								event
																									.target
																									.value,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>
																</div>
																<div className="col-md-12 m-0">
																	<label
																		for="desc"
																		className="form-label"
																	>
																		Description
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																	<input
																		type="text"
																		row="2"
																		className="form-control"
																		id="desc"
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								event
																									.target
																									.value,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									event
																										.target
																										.value,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									event
																										.target
																										.value,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								event
																									.target
																									.value,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>
																</div>
															</div>
														</div>
													</div>
												)
											)}
										</div>
										<div className="btn-group my-2">
											<button
												type="button"
												style={{ width: "3rem" }}
												className="add-btn"
												onClick={() =>
													setProjectCounter([
														...projectCounter,
														PROJECT_STRUCT,
													])
												}
											>
												+
											</button>
											{projectCounter.length > 0 ? (
												<button
													type="button"
													style={{ width: "3rem" }}
													className="sub-btn"
													onClick={() =>
														setProjectCounter([
															...projectCounter.slice(
																0,
																projectCounter.length -
																	1
															),
														])
													}
												>
													-
												</button>
											) : (
												""
											)}
										</div>
										<br />
										<div className="col-12">
											<button
												type="submit"
												className="submit-intern-form-btn"
												onClick={formSubmit}
											>
												submit
											</button>
										</div>
									</form>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default EmployeeForm;
